import { Injectable } from '@angular/core';
import { OpenLabelEditorService } from './open-label-editor.service';
import { UnusedLabelingService } from './unused-labeling.service';

@Injectable({providedIn: 'root'})
export class OpenLabelEditorServiceInitializer {
  constructor(private openLabelEditorService: OpenLabelEditorService,
              private _unusedLabelingService: UnusedLabelingService) {
  }

  public initialize() {
    this.openLabelEditorService.initialize(this._unusedLabelingService);
  }
}
